/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import "./src/styles/fonts/1805-TITXUQ.css";
import "./src/styles/fonts/custom-fonts.css";
import "./src/styles/global.css";
